import { Collapse } from 'antd';
import React from 'react';
import SyntaxHighlighter from '../../SyntaxHighlighter/SyntaxHighlighter';
import ClipboardCopyButton from '../../../ClipboardCopyButton';

const ResponseCard = ({ response }) => {
  const items = [
    {
      key: '1',
      label: 'Body',
      children: <SyntaxHighlighter code={response} language="json" />,
      extra: (
        <ClipboardCopyButton
          data={response}
          toolTipText="Copy response"
          onClickCallback={(event) => event.stopPropagation()}
        />
      ),
    },
  ];
  return (
    <>
      <Collapse defaultActiveKey={['1']} items={items} />
    </>
  );
};

export default ResponseCard;
